import { useEffect, useRef, useState } from "react";
import BlogAdminDetail from "./BlogDetail";
import {
  TabButton,
  TabHeader,
  TabWrapper,
} from "../../../style/admin/Tab_Style";
import Seo from "../Seo";
import { useParams, useNavigate } from "react-router-dom";
import BlogService from "../../../services/api/blog.service";
import { EBlogResponse } from "../../../models/blog";
import { toast } from "../../../utils/notify";
import BlogDetail from "./BlogDetail";
import {
  Button,
  ModalFooter,
} from "../../../style/admin/BlogCreateModal_Style";
import SeoService from "../../../services/api/seo.service";
import { ESeoResponse } from "../../../models/seo";
import FaqAdmin from "../FaqAdmin";
import { FaqItem } from "../../../models/faq";
import FaqService from "../../../services/api/faq.service";
import { CountryLanguage } from "../../../i18n/i18n";
import BlogFooterService from "../../../services/api/blogfooter.service";

const BlogFooterDetailPage = () => {
  const [tab, setTab] = useState<"blog" | "seo" | "faq">("blog");
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [blog, setBlog] = useState<EBlogResponse | null>(null);
  const [seo, setSeo] = useState<ESeoResponse | null>(null);
  const [faq, setFaq] = useState<FaqItem[]>([]);

  const [objId, setObjId] = useState<string | null>(null);

  const blogRef = useRef<any>(null);
  const seoRef = useRef<any>(null);
  const faqRef = useRef<any>(null);

  const handleSave = async () => {
    try {
      const seoValid = await seoRef.current?.validate();
      const blogValid = await blogRef.current?.validate();
      // const faqValid = await faqRef.current?.validate();
      //|| !faqValid
      if (!seoValid || !blogValid) {
        return;
      }

      await blogRef.current?.submit();
      await seoRef.current?.submit();
      //await faqRef.current?.submit();

      await fetchDetail();

      toast(id ? "Cập nhật thành công" : "Thêm mới thành công", "success");
    } catch (err) {
      toast("Lỗi khi lưu dữ liệu", "error");
    }
  };

  const fetchDetail = async () => {
    if (!id) {
      const newObjId = crypto.randomUUID();
      setObjId(newObjId);
      return;
    }

    const res = await BlogFooterService.getSingle(id);
    if (res.success) {
      setBlog(res.data);
      res.data.id && setObjId(res.data.id);
    } else {
      toast("Không tìm thấy blog", "error");
      navigate("/admin/support");
    }

    const resSeo = await SeoService.getSeoByObjId(id);
    if (resSeo.success) {
      setSeo(resSeo.data);
    } else {
      toast("Không tìm thấy seo", "error");
      navigate("/admin/support");
    }

    // const resFaq = await FaqService.getSingleByObjId(id);
    // if (resFaq.success) {
    //   setFaq(resFaq.data);
    // } else {
    //   toast("Không tìm thấy faq", "error");
    //   navigate("/admin/blog");
    // }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);
  return (
    <>
      {/* TAB HEADER */}
      <TabHeader>
        <TabButton active={tab === "blog"} onClick={() => setTab("blog")}>
          📝 Support
        </TabButton>

        <TabButton active={tab === "seo"} onClick={() => setTab("seo")}>
          🔍 SEO
        </TabButton>

        {/* <TabButton active={tab === "faq"} onClick={() => setTab("faq")}>
          💬 FAQ
        </TabButton> */}
      </TabHeader>

      <ModalFooter>
        <Button onClick={handleSave} type="submit">
          Lưu
        </Button>
        <Button
          type="button"
          className="cancel"
          onClick={() => navigate("/admin/support")}>
          Đóng
        </Button>
      </ModalFooter>

      {/* TAB CONTENT */}
      <TabWrapper>
        <div style={{ display: tab === "blog" ? "block" : "none" }}>
          <BlogDetail ref={blogRef} blog={blog} objId={objId} />
        </div>

        <div style={{ display: tab === "seo" ? "block" : "none" }}>
          <Seo ref={seoRef} seoProp={seo} objId={objId} />
        </div>

        {/* <div style={{ display: tab === "faq" ? "block" : "none" }}>
          <FaqAdmin ref={faqRef} faqItems={faq} objIdProp={objId} />
        </div> */}
      </TabWrapper>
    </>
  );
};

export default BlogFooterDetailPage;
